import { decode } from 'base64-arraybuffer';
import fileSaver from 'file-saver';

/**
 * Save blob file that came from back-end. (wrapper around fileSaver.saveAs).
 * @param blob - Blob content to save
 * @param fileName - Optional filename
 */
export const saveFileAs = (blob: Blob, fileName?: string): void => {
  fileSaver.saveAs(blob, fileName);
};

export interface AttachmentFile {
  name?: string;
  content: string;
}

/**
 * Encode and save file that came as string from back-end.
 * @param attachment - An object with file definition (blob string and optional file name)
 */
export const saveAttachmentFile = (attachment: AttachmentFile): void => {
  const blob = new window.Blob([decode(attachment.content)]);
  saveFileAs(blob, attachment.name);
};
